async function getAndRenderAds() {
    let id = localStorage.getItem("id");
    let ref = localStorage.getItem("ref");
    let advt;

    let headers = { "Content-Type": "application/json" };
    if (typeof site !== 'undefined' && site !== '') {
        headers.site = site;
    }

    if (typeof ghostMemberId !== 'undefined' && ghostMemberId) {
        headers.ghostMemberId = ghostMemberId;
    } else if (id) {
        headers.contactId = id;
    } else if (ref) {
        headers.ref = ref;
    } 

    // fetch ad banner
    try {
        const baseUrl = typeof cmsUrl !== 'undefined' ? cmsUrl : "https://cms.breakingbank.media";
        const res = await fetch(baseUrl + "/api/banners", {
            method: "GET",
            headers: headers
        });
        advt = await res.json();
    } catch (error) {
        console.error("Error fetching banners:", error);
        return;
    }

    // render ad banner
    const headerAdElement = document.querySelector(".header-ad");
    const sidebarAdElement = document.querySelector(".sidebar-ad");
    const footerAdElement = document.querySelector(".footer-ad");
    
    const baseUrl = typeof cmsUrl !== 'undefined' ? cmsUrl : "https://cms.breakingbank.media";

    if (advt.adBanner?.headerAd?.image && headerAdElement) {
        renderAd(headerAdElement, advt.adBanner?.headerAd, baseUrl, advt.adBanner?.headerAd?.fallback);
        // trackAdView(advt.adBanner?.headerAd, advt.adBanner?.headerAd?.fallback);
    }
    if (advt.adBanner?.sidebarAd?.image && sidebarAdElement) {
        renderAd(sidebarAdElement, advt.adBanner?.sidebarAd, baseUrl, advt.adBanner?.sidebarAd?.fallback);
    }
    if (advt.adBanner?.footerAd?.image && footerAdElement) {
        renderAd(footerAdElement, advt.adBanner?.footerAd, baseUrl, advt.adBanner?.footerAd?.fallback);
    }
    addRefToUrl(advt?.ref);
}

function renderAd(element, adBanner, baseUrl, fallback = false) {
    const eventName = fallback ? "fallback-advt-click" : "advt-click";
    const bannerIdAttribute = fallback ? "fallback-banner-id" : "banner-id";

    element.innerHTML = `
        <a href="${adBanner?.link ?? ""}" 
           target="_blank" 
           rel="noopener" 
           data-umami-event="${eventName}" 
           data-umami-event-${bannerIdAttribute}="${adBanner?.id}" >
            <img width="100%" 
                 src="${baseUrl}${adBanner?.image}" 
                 alt="ad-banner">
        </a>
    `;
    element.style.display = "block";
}

// function trackAdView(adBanner, fallback = false) {
//     const eventName = fallback ? "fallback-advt-view" : "advt-view";
//     const bannerIdAttribute = fallback ? "fallback-banner-id" : "banner-id";
//     if (typeof umami !== 'undefined' && typeof umami.track === 'function') {
//         umami.track(eventName, {
//             [bannerIdAttribute]: adBanner?.id,
//             position: 'header',
//         });
//     } else {
//         console.warn("Umami tracking is not loaded.");
//     }
// }

function addRefToUrl(ref) {
    // Select all anchor tags inside content blocks
    const links = document.querySelectorAll(".gh-post-content a, .gh-content a");
    links.forEach((link) => {
        const href = link.getAttribute("href");
        if (href) {
            try {
                const url = new URL(href, window.location.href);
                // Set or overwrite the ref parameter
                const finalRef = localStorage.getItem("ref") || ref;
                if (finalRef) {
                    url.searchParams.set("ref", finalRef);
                    link.href = url.toString();
                }
            } catch (e) {
                console.error(`Invalid URL: ${link.href}`, e);
            }
        }
    });
}
